<template>
    <v-dialog v-model="show" no-click-animation persistent width="1200">
        <div class="AgentQuickReaction">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('quickReaction.setting') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Content dialog-->
            <div class="dialog-content">
                <v-select
                    hide-details outlined
                    v-model="mode"
                    :items="ModeLabel"
                    class="input-custom p-12"
                    item-text="label"
                    item-value="value"
                    :readonly="!isEdit"
                ></v-select>
                <div v-show="mode===Mode.NLP">
                    <div class="centerY p-12 pb-0">
                        <div class="label mb-0" style="width: 15%;">{{ $f.tc('quickReaction.nluEndPoint') }}</div>
                        <v-text-field
                            outlined
                            v-model="nluEndPoint"
                            style="width: 100%"
                            class="input-custom pl-6"
                            :readonly="!isEdit"
                        ></v-text-field>
                    </div>
                    <div class="centerY p-12 pt-0">
                        <div class="label mb-0 mt-6" style="width: 15%;">{{ $f.tc('quickReaction.nluToken') }}</div>
                        <v-text-field
                            outlined
                            v-model="nluToken"
                            style="width: 100%"
                            class="input-custom pl-6"
                            :readonly="!isEdit"
                        ></v-text-field>
                    </div>
                </div>
                <div v-if="mode===Mode.NO" style="height: 444px"></div>
                <div v-if="mode!==Mode.NO" class="pt-12 fci-scrollbar dialog-content" ref="contentDialog"
                     style="max-height: 300px;padding-top: 0!important; height: 300px">
                    <table style="width: 100%">
                        <thead style="position: sticky !important; top: -1px; z-index:1">
                        <!-- this tr is for border top to follow the header when scrolling -->
                        <tr style="height: 2px !important">
                            <th scope="col" style="padding:0;background: #96add0" colspan="6"></th>
                        </tr>
                        <tr>
                            <th v-show="mode===Mode.NLP" scope="col" style="padding: 12px; width: 170px">
                                <div class="d-flex">
                                    {{ $f.tc('quickReaction.agentAction') }}
                                </div>
                            </th>
                            <th v-show="mode===Mode.NLP" scope="col" style="padding: 12px; width: 170px">
                                <div class="d-flex">
                                    {{ $f.tc('quickReaction.customerIntent') }}
                                </div>
                            </th>
                            <th scope="col" style="padding: 12px">{{ $f.tc('quickReaction.reactionWords') }}</th>
                            <th v-show="mode===Mode.NLP" scope="col" style="padding: 12px; width: 170px">
                                <div class="d-flex">
                                    {{ $f.tc('quickReaction.playingCondition') }}
                                </div>
                            </th>
                            <th scope="col">{{ $f.tc('quickReaction.frequency') }} (%)</th>
                            <th v-show="mode===Mode.NLP" scope="col" v-if="isEdit"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <!--Current variables-->
                        <tr v-for="(item, i) in itemList" :key="i">
                            <td v-show="mode===Mode.NLP">
                                <v-text-field
                                    outlined
                                    hide-details
                                    v-model="item.agent_action"
                                    style="width: 100%"
                                    class="input-custom"
                                    :readonly="!isEdit"
                                ></v-text-field>
                            </td>
                            <td v-show="mode===Mode.NLP">
                                <v-text-field
                                    outlined
                                    hide-details
                                    v-model="item.customer_intent"
                                    style="width: 100%"
                                    class="input-custom"
                                    :readonly="!isEdit"
                                ></v-text-field>
                            </td>
                            <td>
                                <div class="centerY">
                                    <v-text-field
                                        outlined
                                        hide-details
                                        ref="newInterruptPhrase"
                                        type="string"
                                        @keypress.enter="addNewReactionWord(i, false)"
                                        v-model="item.new_reaction_word"
                                        placeholder="Interrupt phase"
                                        class="input-custom"
                                    ></v-text-field>
                                </div>
                                <div class="monitoring-bar centerY scrollbar-horizontal-thin"
                                     :style="mode===Mode.NLP ? {maxWidth: '484px'} : {maxWidth: '1058px' }">
                                    <div class="centerY mr-6" style="gap: 6px;flex-wrap: wrap"
                                         v-if="item.reaction_words && item.reaction_words.length > 0">
                                        <div class="tag-item centerXY"
                                             v-for="(phrase, phraseIndex) in item.reaction_words"
                                             :key="phrase">
                                            {{ phrase }}
                                            <img src="/img/debug/close-circle.svg" alt="icon-close"
                                                 @click="deleteReactionWord(i, phraseIndex,false)" v-if="phrase">
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td v-show="mode===Mode.NLP">
                                <v-text-field
                                    outlined
                                    hide-details
                                    v-model="item.playing_condition"
                                    style="width: 100%"
                                    class="input-custom"
                                    :readonly="!isEdit"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                    outlined
                                    hide-details
                                    type="number"
                                    v-model="item.frequency"
                                    :min="0"
                                    :max="100"
                                    @focusout="validateFrequency(i)"
                                    class="input-custom input-number"
                                ></v-text-field>
                            </td>
                            <td v-show="mode===Mode.NLP" v-if="isEdit">
                                <div class="pt-8">
                                    <v-btn icon class="mx-0" @click.stop="deleteItem(i)">
                                        <img
                                            src="/img/delete-blue.svg"
                                            alt="icon-delete"
                                            style="transform: scale(1.3); padding-left: 1px"
                                        >
                                    </v-btn>
                                </div>

                            </td>
                        </tr>
                        <!--New variable-->
                        <tr v-show="mode===Mode.NLP" v-if="isEdit">
                            <td>
                                <v-text-field
                                    outlined
                                    hide-details
                                    v-model="model.agent_action"
                                    style="width: 100%"
                                    class="input-custom pb-12"
                                    :readonly="!isEdit"
                                    ref="NewKeyVariable"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                    outlined
                                    hide-details
                                    v-model="model.customer_intent"
                                    style="width: 100%"
                                    class="input-custom pb-12"
                                    :readonly="!isEdit"
                                ></v-text-field>
                            </td>
                            <td>
                                <div class="centerY">
                                    <v-text-field
                                        outlined
                                        hide-details
                                        ref="newInterruptPhrase"
                                        type="string"
                                        @keypress.enter="addNewReactionWord(0, true)"
                                        v-model="model.new_reaction_word"
                                        placeholder="Interrupt phase"
                                        class="input-custom"
                                        :style="model.reaction_words && model.reaction_words.length > 0 ? '' : {paddingBottom: '12px'}"
                                    ></v-text-field>
                                </div>
                                <div v-if="model.reaction_words && model.reaction_words.length > 0"
                                     class="monitoring-bar centerY scrollbar-horizontal-thin"
                                     :style="mode===Mode.NLP ? {maxWidth: '484px'} : {maxWidth: '1058px' }">
                                    <div class="centerY mr-6" style="gap: 6px;flex-wrap: wrap">
                                        <div class="tag-item centerXY"
                                             v-for="(phrase, phraseIndex) in model.reaction_words"
                                             :key="phrase">
                                            {{ phrase }}
                                            <img src="/img/debug/close-circle.svg" alt="icon-close"
                                                 @click="deleteReactionWord(0, phraseIndex, true)" v-if="phrase">
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <v-text-field
                                    outlined
                                    hide-details
                                    v-model="model.playing_condition"
                                    style="width: 100%"
                                    class="input-custom pb-12"
                                    :readonly="!isEdit"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                    outlined
                                    hide-details
                                    type="number"
                                    v-model="model.frequency"
                                    :min="0"
                                    :max="100"
                                    @focusout="validateNewFrequency()"
                                    class="input-custom input-number pb-12"
                                ></v-text-field>
                            </td>
                            <td>
                                <div class="pt-8">
                                    <v-btn icon class="mx-0" @click.stop="addItem">
                                        <img src="/img/add-blue.svg" alt="icon-delete" style="transform: scale(1.4);">
                                    </v-btn>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="mode===Mode.SIMPLE" style="height: 144px"></div>
            </div>
            <!--Footer dialog-->
            <div class="dialog-footer" v-if="isEdit">
                <div class="btn-outline mr-6" @click="importQuickReaction">
                    <img src="/img/add-blue.svg" alt="icon-add-mapping-excel"
                         style="margin-right: 6px; transform: scale(1.1)">
                    {{ $f.tc('importFromExcel') }}
                    <input type="file" :hidden="true" ref="InputQuickReaction" accept=".xlsx, .xls, .csv"
                           @change="handleFile">
                </div>
                <div class="btn-outline mr-6" @click="downloadTemplate"
                     :title="$f.tc('downloadTemplateExcel')">
                    <img src="/img/scenario/download_blue.svg" alt="icon-download-template"
                         style="margin-right: 6px; transform: scale(1.1)">
                    {{ $f.tc('export') }}
                </div>
                <div class="btn-custom"
                     @click="saveQuickReactionConfig">{{ $f.tc('save') }}
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseMixin from "@/modules/fptai/mixins/DialogPromiseMixin.vue";
import AgentService from "@/services/agent.service";
import {mapState} from "vuex";
import FormMixin from "@/modules/fptai/mixins/FormMixin.vue";
import $const from "@/utils/const";

const Mode = {
    NO: 'no',
    SIMPLE: 'simple',
    NLP: 'nlp',
}

const defaultReaction = {
    "agent_action": "",
    "customer_intent": "",
    "new_reaction_word": "",
    "reaction_words": [],
    "playing_condition": "",
    "frequency": 100
}

export default {
    name: "AgentQuickReaction",
    mixins: [DialogPromiseMixin, FormMixin],
    computed: {
        ...mapState({
            quickReaction: state => state.agent.quick_reaction,
            agent: state => state.agent.agent
        }),
        isEdit() {
            return AgentService.isEditable()
        },
        ModeLabel() {
            return [
                {
                    "label": this.$t('quickReaction.label.no'),
                    "value": "no"
                },
                {
                    "label": this.$t('quickReaction.label.simple'),
                    "value": "simple"

                },
                {
                    "label": this.$t('quickReaction.label.nlp'),
                    "value": "nlp"

                },
            ]
        }
    },
    data() {
        return {
            Mode,
            mode: "",
            defaultQuickReactionConfig: {},
            nluEndPoint: "",
            nluToken: "",
            quickReactionConfigs: [],
            itemList: [],
            reactions: {},
            model: this.$utils.cloneObject(defaultReaction),
        }
    },
    methods: {
        saveQuickReactionConfig() {
            if (this.checkQuickReactionValid()) {
                let tempList = this.$utils.cloneObject(this.itemList)
                tempList.forEach(item => {
                    item.agent_action = item.agent_action.trim()
                    item.customer_intent = item.customer_intent.trim()
                    item.reaction_words = item.reaction_words.map(i => i.trim()).join(';')
                    item.frequency = parseInt(item.frequency)
                    if (!item.playing_condition) {
                        item.playing_condition = ''
                    } else {
                        item.playing_condition = item.playing_condition.trim()
                    }
                })
                this.reactions[this.mode] = tempList
                this.$store.dispatch(this.$actionTypes.agent.UPDATE_QUICK_REACTION, {
                    id: this.quickReaction.id,
                    value: {
                        mode: this.mode,
                        nlp_endpoint: this.nluEndPoint,
                        nlp_token: this.nluToken,
                        reactions: this.reactions,
                    }
                }).then(() => {
                    this.close()
                })
            }
        },
        loadQuickReaction() {
            this.mode = Object.keys(this.quickReaction.value).length === 0 ? Mode.NO : this.quickReaction.value.mode
            this.itemList = []
            this.setValue()
        },
        open() {
            this.show = true
            this.loadQuickReaction()
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        },
        close() {
            this.show = false
            this.itemList = []
            this.mode = ""
            this.$emit('close')
        },
        newQuickReactionIsValid() {
            if (!this.model.agent_action.trim() && !this.model.customer_intent.trim()) {
                this.$appService.toastError(this.$f.tc('quickReaction.intentAndActionInfo'))
                return false
            }

            if (this.itemList.find(item => (item.customer_intent === this.model.customer_intent &&
                item.agent_action === this.model.agent_action &&
                item.playing_condition === this.model.playing_condition))) {
                this.$appService.toastError(this.$f.tc('quickReaction.fieldItemDuplicate', [
                    this.$f.tc('quickReaction.agentAction'),
                    this.$f.tc('quickReaction.customerIntent'),
                    this.$f.tc('quickReaction.playingCondition')
                ]))
                return false
            }

            let trimmed = this.model.reaction_words.filter(str => str.trim() !== "")

            if (trimmed.length === 0) {
                this.$appService.toastError(this.$f.tc('itemFieldRequired', {item: this.$f.tc('quickReaction.reactionWords')}))
                return false
            }

            return true
        },
        checkQuickReactionValid() {
            if (this.mode !== Mode.NLP) {
                return true
            }

            if (!this.nluEndPoint || !this.nluToken) {
                this.$appService.toastError(this.$f.tc('quickReaction.nluInfo'))
                return false
            }

            if (this.itemList.length === 0) {
                this.$appService.toastError(this.$f.tc('quickReaction.addItem'))
                return false
            }

            // check duplicate agent action and customer intent and playing condition
            const keys = this.itemList.flatMap(i => `${i['agent_action']}-${i['customer_intent']}-${i['playing_condition']}`);
            const set = new Set();
            for (const key of keys) {
                if (!set.has(key)) {
                    set.add(key);
                } else {
                    this.$appService.toastError(this.$f.tc('quickReaction.fieldItemDuplicate', [
                        this.$f.tc('quickReaction.agentAction'),
                        this.$f.tc('quickReaction.customerIntent'),
                        this.$f.tc('quickReaction.playingCondition')
                    ]))
                    return false;
                }
            }

            for (let item of this.itemList) {
                if (!item.agent_action.trim() && !item.customer_intent.trim()) {
                    this.$appService.toastError(this.$f.tc('quickReaction.intentAndActionInfo'))
                    return false
                }

                if (!this.isValidReactionWords(item)) {
                    return false
                }
            }

            return true
        },
        addItem() {
            if (this.newQuickReactionIsValid()) {
                this.itemList.push(this.model)
                this.scrollBottom()
                this.model = this.$utils.cloneObject(defaultReaction)
                this.$refs.NewKeyVariable.$el.focus()
            }
        },
        deleteItem(index) {
            this.itemList.splice(index, 1)
        },
        setValue() {
            let keysLength = Object.keys(this.quickReaction.value).length
            if (keysLength > 1) {
                this.nluToken = this.quickReaction.value.nlp_token
                this.nluEndPoint = this.quickReaction.value.nlp_endpoint
                this.reactions = this.quickReaction.value.reactions
                if (this.quickReaction.value.reactions[this.mode]) {
                    this.quickReaction.value.reactions[this.mode].forEach(obj => {
                        let tempObj = this.$utils.cloneObject(obj)
                        let type = typeof tempObj.reaction_words
                        if (type === 'string') {
                            tempObj.reaction_words = tempObj.reaction_words.split(';')
                        }
                        tempObj.new_reaction_word = ""
                        this.itemList.push(tempObj)
                    })
                }
            }
            if (this.mode === Mode.SIMPLE && this.itemList.length === 0) {
                this.itemList.push(this.$utils.cloneObject(defaultReaction))
            }
        },
        validateFrequency(index) {
            if (parseInt(this.itemList[index].frequency) <= -1) {
                this.itemList[index].frequency = 100
            }

            if (!this.itemList[index].frequency) {
                this.itemList[index].frequency = 100
            }

            if (this.itemList[index].frequency > 100) {
                this.itemList[index].frequency = 100
            }

            if (this.itemList[index].frequency < 0) {
                this.itemList[index].frequency = 0
            }
        },
        validateNewFrequency() {
            if (parseInt(this.model.frequency) <= -1) {
                this.model.frequency = 100
            }

            if (!this.model.frequency) {
                this.model.frequency = 100
            }

            if (this.model.frequency > 100) {
                this.model.frequency = 100
            }

            if (this.model.frequency < 0) {
                this.model.frequency = 0
            }
        },
        scrollBottom() {
            this.$nextTick(() => {
                this.$refs.contentDialog.scrollTo({
                    top: this.$refs.contentDialog.scrollHeight
                })
            })
        },
        isValidReactionWords(item) {
            // check empty string
            let trimmed = item['reaction_words'].filter(str => str.trim() !== "")
            if (trimmed.length === 0) {
                this.$appService.toastError(this.$f.tc('itemFieldRequired', {item: this.$f.tc('quickReaction.reactionWords')}))
                return false
            }
            return true;
        },
        importQuickReaction() {
            this.$refs.InputQuickReaction.click()
        },
        handleFile(event) {
            this.file = event.target.files[0]
            let extFile = event.target.files[0].type
            if (this.file.size <= 1024 * 1024 && $const.ExcelTypes.includes(extFile)) {
                let formData = new FormData()
                formData.append('file', this.file)
                this.$appService.showLoading()
                this.$http.post(
                    `/tova-agents/${this.$route.params.agentId}/import-quick-reaction/`,
                    formData,
                    {headers: {'Content-Type': 'multipart/form-data'}}
                ).then(
                    res => {
                        this.$appService.toastSuccess(res.data['detail'])
                    }
                ).finally(() => {
                    this.$appService.hideLoading()
                    this.file = null
                    this.$refs.InputQuickReaction.value = null
                    AgentService.SettingService.search(this.$route.params.agentId).then(
                        result => {
                            this.$store.dispatch(this.$actionTypes.agent.SET_SETTING, result.data)
                        }
                    ).finally(() => {
                        this.loadQuickReaction()
                    })
                })

            } else {
                this.$appService.toastError('invalid file')
            }
        },
        downloadTemplate() {
            let agent_id = this.$route.params.agentId
            AgentService.getQuickReactionTemplate(agent_id).then(res => {
                this.$utils.saveFile(res.data, this.$filters.replaceSpecialCharacters(this.$utils.nonAccentVietnamese(this.agent.name + ' - quick reaction template')), '.xlsx')
            })
        },
        deleteReactionWord(index, phraseIndex, isNew) {
            if (isNew) {
                let phraseList = this.model.reaction_words
                if (phraseList.length === 0) {
                    this.$appService.toastError(this.$f.tc('interruptPhrasesEmpty', [0]))
                    return
                }
                phraseList.splice(phraseIndex, 1)
                return
            }
            let phraseList = this.itemList[index].reaction_words
            if (phraseList.length === 0) {
                this.$appService.toastError(this.$f.tc('interruptPhrasesEmpty', [index]))
                return
            }
            phraseList.splice(phraseIndex, 1)
        },
        addNewReactionWord(index, isNew) {
            if (isNew) {
                let newPhrase = this.model.new_reaction_word.trim()
                // validate duplicate
                if (this.model.reaction_words.includes(newPhrase)) {
                    this.$appService.toastError(this.$f.tc('quickReaction.reactionWordsDuplicate'))
                    this.model.new_reaction_word = ""
                    return
                }
                if (!newPhrase || newPhrase === '') {
                    this.$appService.toastError(this.$f.tc('quickReaction.reactionWordBlank'))
                    this.model.new_reaction_word = ""
                    return
                }
                this.model.reaction_words.push(newPhrase)
                this.model.new_reaction_word = ""
                return
            }
            let newPhrase = this.itemList[index].new_reaction_word.trim()
            // validate duplicate
            if (this.itemList[index].reaction_words.includes(newPhrase)) {
                this.$appService.toastError(this.$f.tc('quickReaction.reactionWordsDuplicate'))
                this.itemList[index].new_reaction_word = ""
                return
            }
            if (!newPhrase || newPhrase === '') {
                this.$appService.toastError(this.$f.tc('quickReaction.reactionWordBlank'))
                this.itemList[index].new_reaction_word = ""
                return
            }
            this.itemList[index].reaction_words.push(newPhrase)
            this.itemList[index].new_reaction_word = ""
        },
    },
    watch: {
        mode: {
            deep: true,
            immediate: true,
            handler: function (newValue, oldValue) {
                if (newValue && oldValue) {
                    this.itemList = []
                    this.setValue()
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
.AgentQuickReaction {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .dialog-content {
        padding: 12px;
        max-height: calc(85vh - 100px);
        overflow-y: auto;
    }
}

.quick-reaction-label {
    margin-left: 20px;
    margin-top: 12px;
}

table {
    border: 1px solid #96add0;
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    tr {
        height: 48px;
        border-bottom: 1px solid #96add0;
        td {
            padding: 0 6px;
            vertical-align: top;

            &:first-child {
                padding-left: 12px;
            }
        }
    }

    thead tr:not(.v-datatable__progress) {
        height: 48px !important;
    }

    thead th {
        text-transform: capitalize !important;
        color: #12274F !important;
        background: #E4EDFA;
        text-align: left;
    }

    th:nth-child(1) {
        padding-left: 12px;
    }

    th:nth-child(2) {
        padding-left: 6px;
    }

    th:nth-child(4) {
        padding-left: 6px;
        width: 15%;
    }

    th:nth-last-child(2) {
        width: 8%;
    }

    th:nth-last-child(1) {
        width: 3%;
    }
}

.input-custom-2 {
    ::v-deep {
        .v-input__slot {
            border-radius: 5px;
            border: 1px solid #DBDBDB !important;
            outline: none;
            outline-offset: 0;
            font-size: 14px;
            margin: 0;
            padding: 0 12px;
        }
    }
}

.monitoring-bar {
    padding: 8px 0;
    background: #FFFFFF;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;

    .tag-item {
        padding: 0 6px 0 8px;
        height: 25px;
        line-height: 25px;
        background: #EAEEFF;
        color: #0052CC;
        border-radius: 4px;
        font-size: 13px;
        font-family: "open sans", serif;

        img {
            cursor: pointer;
            width: 18px;
            margin-left: 3px;
        }
    }
}
</style>
